import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/baseInformation/advertising';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchListByType } from '@/api/PMS/dic/dic';
export default {
  props: ['routerIdArr', 'keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        upIdList: [{
          required: true,
          message: '请选择上级机构',
          trigger: 'blur'
        }],
        adCode: [{
          required: true,
          message: '请输入广告位号',
          trigger: 'blur'
        }],
        floor: [{
          required: true,
          message: '请输入楼层',
          trigger: 'blur'
        }],
        adStatus: [{
          required: true,
          message: '请选择状态',
          trigger: 'blur'
        }]
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      childData: {
        upIdList: []
      },
      unintId: [],
      statueOption: [],
      options: [],
      cascaderItem: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.unintId = [];
      this.statueOption = [];
      this.loadAdStatue();
      this.loadMenuTree();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.childData.upIdList = _this.childData.upIdList.join(',').split(',');
          _this.unintId = _this.childData.unintId;
        });
      } else {
        this.childData = {
          adStatus: 0
        };
        this.childData.upIdList = [];
        this.childData.upIdList.push(this.routerIdArr[0]);
        setTimeout(function () {
          _this.getCascaderItem(_this.childData.upIdList, _this.options);
        }, 1000);
      }
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      var treeQuery = {
        flag: 21
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.options = response.data.data;
      });
    },
    loadAdStatue: function loadAdStatue() {
      var _this3 = this;

      fetchListByType('ad_status').then(function (r) {
        _this3.statueOption = r.data.data;
      });
    },
    // 获取级联选择器的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this4 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this4.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    getNode: function getNode() {
      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);
    },
    handCreate: function handCreate() {
      var _this5 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this5.childData.unintId = _this5.childData.upIdList[_this5.childData.upIdList.length - 1];

          if (_this5.keyValue > 0) {
            delete _this5.childData.upIdList;
            fetchUpdate(_this5.childData).then(function () {
              _this5.$emit('handCancle', true);

              _this5.Alert({
                alertType: 'update'
              });
            });
          } else {
            if (_this5.cascaderItem[_this5.cascaderItem.length - 1].flag !== '21') {
              _this5.$message({
                message: '上级机构请选择正确的楼栋单元',
                type: 'error',
                duration: 3000
              });

              return false;
            }

            delete _this5.childData.upIdList;
            fetchCreate(_this5.childData).then(function () {
              _this5.$emit('handCancle', true);

              _this5.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this5.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'offAdvertisingEdit');
    }
  }
};